export const SET_STONES = "STONE/SET_STONES"
export const SELECT_STONE = "STONE/SELECT_STONE"
export const SET_STONE_DETAIL = 'STONE/SET_STONE_DETAIL'
export const RESET_STONE_FILTERS = 'STONE/RESET_FILTERS'


export const SET_USER = 'USER/SET_USER'
export const SET_USERS_LIST = 'USER/SET_USERS_LIST'

export const SET_ALERT = 'ALERTES/SET_ALERT'